import AppointmentService from './appointments/appointmentService'
import ClientService from './clients/clientService'
import LocationService from './locations/locationService'
import NoteService from './notes/noteService'
import ScheduleService from './schedule/scheduleService'

export default {
  AppointmentService,
  ClientService,
  LocationService,
  NoteService,
  ScheduleService
}
